/**
 * @typedef {Object} ColorPickerProps
 * @property {string} currentColor
 * @property {(color: string) => void} onColorChange
 * @property {() => void} onClose
 */

export const PRESET_COLORS = [
  "#000000",
  "#ffffff",
  "#ff0000",
  "#00ff00",
  "#0000ff",
  "#ffff00",
  "#00ffff",
  "#ff00ff",
  "#c0c0c0",
  "#808080",
  "#800000",
  "#808000",
  "#008000",
  "#800080",
  "#008080",
  "#000080",
];
